import React from 'react';
import { ImageOutlined } from '@mui/icons-material';
import { Image, ImagePropsSchema } from './Image';
import ImageSidebarPanel from './ImageSidebarPanel';
export default {
    label: 'Image',
    icon: React.createElement(ImageOutlined, null),
    type: 'Image',
    defaultData: {
        props: {
            url: 'https://assets.usewaypoint.com/sample-image.jpg',
            alt: 'Sample product',
            contentAlignment: 'middle',
            linkHref: null,
        },
        style: { padding: { top: 16, bottom: 16, left: 24, right: 24 } },
    },
    SidebarPanel: ImageSidebarPanel,
    Component: Image,
    schema: ImagePropsSchema,
};
//# sourceMappingURL=index.js.map